export default {
  "login": "Indranil-Sarmah",
  "id": 25829322,
  "node_id": "MDQ6VXNlcjI1ODI5MzIy",
  "avatar_url": "https://avatars.githubusercontent.com/u/25829322?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/Indranil-Sarmah",
  "html_url": "https://github.com/Indranil-Sarmah",
  "followers_url": "https://api.github.com/users/Indranil-Sarmah/followers",
  "following_url": "https://api.github.com/users/Indranil-Sarmah/following{/other_user}",
  "gists_url": "https://api.github.com/users/Indranil-Sarmah/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/Indranil-Sarmah/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/Indranil-Sarmah/subscriptions",
  "organizations_url": "https://api.github.com/users/Indranil-Sarmah/orgs",
  "repos_url": "https://api.github.com/users/Indranil-Sarmah/repos",
  "events_url": "https://api.github.com/users/Indranil-Sarmah/events{/privacy}",
  "received_events_url": "https://api.github.com/users/Indranil-Sarmah/received_events",
  "type": "User",
  "site_admin": false,
  "name": "INDRANIL SARMAH",
  "company": null,
  "blog": "",
  "location": "Guawahati, Assam (India)",
  "email": null,
  "hireable": null,
  "bio": "Aspiring Full-Stack developer\r\n",
  "twitter_username": null,
  "public_repos": 27,
  "public_gists": 1,
  "followers": 4,
  "following": 7,
  "created_at": "2017-02-16T20:05:29Z",
  "updated_at": "2021-05-07T14:45:06Z"
};
